(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5212],{

/***/ 2437:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer/agreement",
      function () {
        return __webpack_require__(5544);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5544:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(7379);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var components_layout_headers_Both__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3496);
/* harmony import */ var cds_buttons_Icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7732);
/* harmony import */ var cds_icons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6643);
/* harmony import */ var cds_layout_Main__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3475);
/* harmony import */ var components_layout__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9809);
/* harmony import */ var components_molecules_common_HorizontalSlider__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8000);
/* harmony import */ var cds_buttons_Outline__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5472);
/* harmony import */ var hooks_common_useMetaData__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(6016);
/* harmony import */ var hooks_bridge_useCommonBridge__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(5397);
/* harmony import */ var cds_styles__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(3887);





// components





// components


// hooks


// styles

function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  width: 1800px;\n  padding: 24px 16px;\n  counter-reset: policy-counter;\n\n  ",
        " {\n    padding: 48px 72px 64px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  width: 1800px;\n  max-width: 100%;\n  padding: 0 0 32px;\n  margin: 0 auto;\n\n  & ul {\n    padding: 0;\n  }\n\n  & li {\n    & ~ * {\n      margin-left: 8px;\n    }\n  }\n\n  ",
        " {\n    padding: 0 0 48px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n          &::before {\n            background-color: rgba(0, 0, 0, 0.04);\n          }\n        "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n        &::before {\n          background-color: rgba(0, 0, 0, 0.04);\n        }\n      "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  flex-grow: 0;\n  height: 32px;\n  padding: 0 12px;\n  white-space: nowrap;\n  border-radius: 32px;\n  border: ",
        ";\n  background-color: ",
        ";\n  color: ",
        ";\n  font-size: 12px;\n\n  &::before {\n    z-index: 0;\n    border-radius: 32px;\n  }\n\n  & > div {\n    padding-right: 8px;\n    margin-left: 4px;\n    z-index: 1;\n  }\n\n  ",
        " {\n    &:hover {\n      ",
        ";\n    }\n  }\n\n  &:active {\n    ",
        ";\n  }\n\n  ",
        " {\n    height: 40px;\n    padding: 0 16px;\n    font-size: 14px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
var itemList = [
    '2022.01.03',
    '2021.11.02',
    '2021.08.05',
    '2021.01.01'
];
/** 이용약관 페이지 */ var AgreementPage = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), Content = ref[0], setContent = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(itemList[0]), item = ref1[0], setItem = ref1[1];
    var MetaTitle = (0,hooks_common_useMetaData__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)().MetaTitle;
    var ItemList = itemList.map(function(v, idx) {
        var name = v.replace(/\./gi, '');
        var Component = (0,next_dynamic__WEBPACK_IMPORTED_MODULE_3__["default"])(function() {
            return __webpack_require__(3207)("./".concat(name));
        });
        var onClick = function() {
            setContent(Component);
            setItem(v);
        };
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TagButton, {
                selected: item === v,
                onClick: onClick,
                children: v
            })
        }, idx));
    });
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var Component = (0,next_dynamic__WEBPACK_IMPORTED_MODULE_3__["default"])(function() {
            return __webpack_require__(3207)("./".concat(itemList[0].replace(/\./g, '')));
        });
        setContent(Component);
    }, []);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MetaTitle, {
                content: "이용약관"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Wrapper, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TagWrapper, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_molecules_common_HorizontalSlider__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            children: ItemList
                        })
                    }),
                    !!Content && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Content, {})
                ]
            })
        ]
    }));
};
var Header = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var onCloseWebView = (0,hooks_bridge_useCommonBridge__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)().onCloseWebView;
    var onBack = function() {
        if (!onCloseWebView()) {
            router.back();
        }
    };
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_layout_headers_Both__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        message: "이용약관",
        leftSide: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(cds_buttons_Icon__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            width: 24,
            height: 54,
            onClick: onBack,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(cds_icons__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                name: "ic_back_m",
                width: 24,
                height: 24,
                fill: cds_styles__WEBPACK_IMPORTED_MODULE_13__/* .palette.grey75 */ .DG.grey75,
                stroke: cds_styles__WEBPACK_IMPORTED_MODULE_13__/* .palette.grey75 */ .DG.grey75
            })
        })
    }));
};
AgreementPage.getLayout = function getLayout(page) {
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_layout__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        mobileHeader: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Header, {}),
        children: page
    }));
};
var Wrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP)(cds_layout_Main__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).withConfig({
    componentId: "sc-69f7a778-0"
})(_templateObject(), cds_styles__WEBPACK_IMPORTED_MODULE_13__/* .mediaQuery.large */ .cy.large);
var TagWrapper = styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-69f7a778-1"
})(_templateObject1(), cds_styles__WEBPACK_IMPORTED_MODULE_13__/* .mediaQuery.xlarge */ .cy.xlarge);
var TagButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP)(cds_buttons_Outline__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z).withConfig({
    componentId: "sc-69f7a778-2"
})(_templateObject4(), function(param) {
    var selected = param.selected;
    return selected ? "1px solid ".concat(cds_styles__WEBPACK_IMPORTED_MODULE_13__/* .palette.BTN.BG */ .DG.BTN.BG) : "1px solid ".concat(cds_styles__WEBPACK_IMPORTED_MODULE_13__/* .palette.system.grey */ .DG.system.grey);
}, function(param) {
    var selected = param.selected;
    return selected ? cds_styles__WEBPACK_IMPORTED_MODULE_13__/* .palette.BTN.BG */ .DG.BTN.BG : 'transparent';
}, function(param) {
    var selected = param.selected;
    return selected ? cds_styles__WEBPACK_IMPORTED_MODULE_13__/* .palette.grey75 */ .DG.grey75 : cds_styles__WEBPACK_IMPORTED_MODULE_13__/* .palette.grey50 */ .DG.grey50;
}, cds_styles__WEBPACK_IMPORTED_MODULE_13__/* .onlyHover */ .kC, function(param) {
    var disabled = param.disabled;
    return !disabled && (0,styled_components__WEBPACK_IMPORTED_MODULE_14__/* .css */ .iv)(_templateObject2());
}, function(param) {
    var disabled = param.disabled;
    return !disabled && (0,styled_components__WEBPACK_IMPORTED_MODULE_14__/* .css */ .iv)(_templateObject3());
}, cds_styles__WEBPACK_IMPORTED_MODULE_13__/* .mediaQuery.large */ .cy.large);
/* harmony default export */ __webpack_exports__["default"] = (AgreementPage);


/***/ }),

/***/ 3496:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Both; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(7379);
// EXTERNAL MODULE: ./src/cds/styles.ts
var styles = __webpack_require__(3887);
;// CONCATENATED MODULE: ./src/components/atoms/messages/header/Title.js


// styles

function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-weight: 500;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
/**
 * 헤더 타이틀
 * @param {object} props
 * @param {string} props.message
 */ var HeaderTitleMessage = function(param) {
    var message = param.message;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Message, {
        children: message
    }));
};
var Message = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-f2958021-0"
})(_templateObject(), styles/* palette.grey75 */.DG.grey75);
/* harmony default export */ var Title = (HeaderTitleMessage);

// EXTERNAL MODULE: ./src/components/layout/headers/Base.js
var Base = __webpack_require__(6332);
;// CONCATENATED MODULE: ./src/components/layout/headers/Both.js


// components


// styles

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function Both_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Both_templateObject() {
    var data = Both_taggedTemplateLiteral([
        "\n  border-bottom: ",
        ";\n\n  ",
        " {\n    height: 84px;\n    border-bottom: ",
        ";\n  }\n"
    ]);
    Both_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = Both_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  white-space: nowrap;\n  flex-wrap: nowrap;\n  max-width: 100%;\n  width: ",
        "px;\n  height: 100%;\n  padding: 0 16px;\n  margin: auto;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = Both_taggedTemplateLiteral([
        "\n  flex-basis: 50%;\n  width: 50px;\n\n  &:first-child {\n    display: flex;\n    justify-content: flex-start;\n  }\n\n  &:last-child {\n    display: flex;\n    justify-content: flex-end;\n  }\n\n  svg {\n    fill: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
/**
 * 좌/우 컨텐츠 존재 헤더
 * @param {object} props
 * @param {string} props.message
 * @param {import('react').ReactNode} props.leftSide
 * @param {import('react').ReactNode} props.rightSide
 * @param {import('react').ReactNode} props.centerSide
 * @param {boolean} props.noBorderBottom
 */ var BothHeader = function(_param) {
    var message = _param.message, leftSide = _param.leftSide, centerSide = _param.centerSide, rightSide = _param.rightSide, noBorderBottom = _param.noBorderBottom, props = _objectWithoutProperties(_param, [
        "message",
        "leftSide",
        "centerSide",
        "rightSide",
        "noBorderBottom"
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, _objectSpread({
                noBorderBottom: noBorderBottom
            }, props, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentLayout, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                            children: leftSide
                        }),
                        centerSide && centerSide,
                        !centerSide && /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                            message: message
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                            children: rightSide
                        })
                    ]
                })
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Base/* HeaderBlank */.m, {})
        ]
    }));
};
var Header = (0,styled_components_browser_esm/* default */.ZP)(Base/* default */.Z).withConfig({
    componentId: "sc-77bcfba2-0"
})(Both_templateObject(), function(param) {
    var noBorderBottom = param.noBorderBottom;
    return noBorderBottom ? '' : "1px solid ".concat(styles/* palette.system.BNB */.DG.system.BNB);
}, styles/* mediaQuery.large */.cy.large, function(param) {
    var noBorderBottom = param.noBorderBottom;
    return noBorderBottom ? '' : "1px solid ".concat(styles/* palette.system.grey */.DG.system.grey);
});
var ContentLayout = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-77bcfba2-1"
})(_templateObject1(), styles/* mediaValue.medium */.T8.medium);
var Item = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-77bcfba2-2"
})(_templateObject2(), styles/* palette.grey50 */.DG.grey50);
/* harmony default export */ var Both = (BothHeader);


/***/ }),

/***/ 3207:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./": [
		5544
	],
	"./20210101": [
		8121,
		8121
	],
	"./20210101.js": [
		8121,
		8121
	],
	"./20210805": [
		2291,
		2291
	],
	"./20210805.js": [
		2291,
		2291
	],
	"./20211102": [
		2137,
		2137
	],
	"./20211102.js": [
		2137,
		2137
	],
	"./20220103": [
		3122,
		3122
	],
	"./20220103.js": [
		3122,
		3122
	],
	"./index": [
		5544
	],
	"./index.js": [
		5544
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 3207;
module.exports = webpackAsyncContext;

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2725,1223,5644,9809,9774,2888,179], function() { return __webpack_exec__(2437); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);